<template>
  <div class="container content-block reschedule-activities">
    <h3>Verlopen activiteit herplannen</h3>
    <div class="reschedule-activities-container">
      <RescheduleActivity :key="activity.activityId" v-for="activity in rescheduleData"
                          v-model:planned-date="activity.plannedDate" v-model:cancel="activity.cancel"
                          :activity="activity.activity"></RescheduleActivity>

      <button class="btn btn-sandpiper reschedule-activities-btn" type="button" @click="rescheduleActivities">
        Herplanning bewaren
      </button>
    </div>
  </div>
</template>

<script>
import { ActivityApi } from "sandpiper_api";
import RescheduleActivity from "@/components/Activities/RescheduleActivity";

export default {
  name: "RescheduleActivities",
  components: { RescheduleActivity },
  inject: [ "doApiRequest" ],
  props: {
    activities: Array
  },
  emits: [ "rescheduled" ],
  data()
  {
    return {
      reschedulingActivities: false,
      rescheduleData: []
    };
  },
  methods: {
    async rescheduleActivities()
    {
      if (this.reschedulingActivities) return;

      try
      {
        this.reschedulingActivities = true;

        let rescheduledActivities = [];
        this.rescheduleData.forEach(a =>
        {
          rescheduledActivities.push({ activityId: a.activityId, plannedDate: a.plannedDate, cancel: a.cancel });
        });

        this.nextActivity = await this.doApiRequest(
            () => new ActivityApi().rescheduleActivities(rescheduledActivities));

        this.$emit("rescheduled");
      }
      catch (e)
      {
        // TODO - handle error
        console.error(e);
      }
      finally
      {

        this.reschedulingActivities = false;
      }
    }
  },
  created()
  {
    this.rescheduleData = [];

    this.activities.forEach(a =>
    {
      this.rescheduleData.push({ activityId: a.id, plannedDate: a.plannedDate, cancel: false, activity: a });
    });
  },
  watch: {
    activities(newValue)
    {
      if (newValue && newValue.length > 0)
      {
        this.rescheduleData = [];

        newValue.forEach(a =>
        {
          this.rescheduleData.push({ activityId: a.id, plannedDate: a.plannedDate, cancel: false, activity: a });
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reschedule-activities {
  margin: 25px 0;
  padding: 40px 25px 25px;

  h3 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}

.reschedule-activities-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-gap: 50px 75px;

  .reschedule-activities-btn {
    grid-column-start: 1;
  }
}
</style>